// src/components/LocationPicker.js
import React, { useState } from 'react';
import { MapContainer, TileLayer, Marker, useMapEvents } from 'react-leaflet';
import L from 'leaflet';

function LocationPicker({ onLocationSelect, initialPosition = [18.5204, 73.8567] }) {
  const [position, setPosition] = useState(initialPosition);

  function LocationMarker() {
    useMapEvents({
      click(e) {
        const { lat, lng } = e.latlng;
        setPosition([lat, lng]);
        onLocationSelect(lat, lng);
      },
    });

    return position ? <Marker position={position} /> : null;
  }

  return (
    <div className="border rounded overflow-hidden">
      <p className="text-xs text-gray-500 p-1 bg-gray-50">
        Click on the map to set the exact location
      </p>
      <MapContainer 
        center={position} 
        zoom={15} 
        style={{ height: '200px', width: '100%' }}
      >
        <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
        <LocationMarker />
      </MapContainer>
      {position && (
        <div className="text-xs p-1 bg-gray-50">
          📍 Lat: {position[0].toFixed(6)}, Lng: {position[1].toFixed(6)}
        </div>
      )}
    </div>
  );
}

export default LocationPicker;
